import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./columns";

export function HouseTablePage() {
  return (
    <ServerDataGrid
      initialStateOverride={{
        filter: {
          filterModel: {
            items: [{ field: "house.qty", operator: ">", value: 0 }],
          },
        },
      }}
      columns={columns}
      apiEndpoint="/datagrid/house"
      getRowId={(row) => row.house.id}
      tableName="house"
      enableCreate={false}
      enableSearch={true}
    />
  );
}
